/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MatrikelnummerInputs */

const en__field_matrikelnummer = /** @type {(inputs: _Field_MatrikelnummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student ID`)
};

const de__field_matrikelnummer = /** @type {(inputs: _Field_MatrikelnummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matrikelnummer`)
};

/**
* | output |
* | --- |
* | "Student ID" |
*
* @param {_Field_MatrikelnummerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_matrikelnummer = /** @type {((inputs?: _Field_MatrikelnummerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MatrikelnummerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_matrikelnummer(inputs)
	return de__field_matrikelnummer(inputs)
});